import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

const Banner = () => {
  const data = useStaticQuery(graphql`
    {
      allMasonTestimonialCreative(
        filter: { meta: { name: { eq: "main_banner" } } }
      ) {
        nodes {
          url
          meta {
            name
            testimonial
          }
        }
      }
    }
  `)
  console.log(data);
  return (
    <div className="banner-wrap full-bleed bg-gray-200 overflow-hidden">
      {data.allMasonTestimonialCreative.nodes.map(banner => (
        <a target="_blank" href={banner.meta.testimonial===null?"/":banner.meta.testimonial}>
          <div className="img-wrap w-full h-full">
            <img
              className="w-full h-full object-cover"
              src={banner.url}
              alt="banner image"
            />
          </div>
        </a>
      ))}
    </div>
  )
}

export default Banner
